import { GeoMap } from '@delmonicos/shared-design-system-react/src/components/location/geo-map/geo-map.component';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useTranslation } from 'react-i18next';

import { ConfigurationService } from '@app/core/configuration/configuration.service';

import { NetworkBillingDetailsDetailsView } from '../../../network-billing-details-details/network-billing-details-details.view';
import { NetworkCustomerDetails } from '../../../network-customer-details/network-customer-details.view';
import { NetworkHolderDetailsView } from '../../../network-holder-details/network-holder-details.view';
import { useNetworkContext } from '../../../network.context';
import { InformationCardComponent } from './cards/information-card.component';
import * as css from './information-tab.module.scss';

export const InformationTabComponent = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const network = useNetworkContext();

  const apiKey = ConfigurationService.getGoogleApiKey();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <div className={css.networkDetails}>
      <Stack gap={GapEnum.L} direction="column">
        <InformationCardComponent network={network} />
        <NetworkCustomerDetails customer={network.customer} />
        <Stack flex={1} className={css.mapContainer}>
          {apiKey ? (
            <GeoMap
              mapId="static-map-network-detail"
              apiKey={apiKey}
              zoom={16}
            />
          ) : (
            <Text color={TextColor.Error}>
              {t('global.missing-google-api-key')}
            </Text>
          )}
        </Stack>
      </Stack>
      <Stack gap={GapEnum.L} direction="column" className={css.flexedItems}>
        <NetworkHolderDetailsView holder={network.holder} />
        <NetworkBillingDetailsDetailsView
          billingDetails={network.billingDetails}
        />
      </Stack>
    </div>
  );
};
